import MDTypography from "components/MDTypography";
import * as React from "react";
import Tooltip from "@mui/material/Tooltip";

function CTLBillingTraceCell({ value, row, suffix }) {
  const truncatedValue =
    value?.length > 40 ? value.slice(0, 40) + "....." : value;
  const callTrace = window?.enableTraceCall ? row?.original?.callTrace : true;

  const textColor = callTrace === true ? "" : "red";

  return (
    <Tooltip title={value}>
      <MDTypography
        variant="caption"
        fontWeight="bold"
        sx={{ color: textColor }}
      >
        {truncatedValue}
        {suffix && (
          <MDTypography
            variant="caption"
            fontWeight="bold"
            sx={{ color: textColor }}
          >
            &nbsp;&nbsp;{suffix}
          </MDTypography>
        )}
      </MDTypography>
    </Tooltip>
  );
}

CTLBillingTraceCell.defaultProps = {
  suffix: "",
};

export default CTLBillingTraceCell;
